export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// ./~/d3-axis/src/array.js
// module id = PiPf
// module chunks = 0